/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import {
    FaFacebookF,
    FaFacebookMessenger,
    FaGithub,
    FaLinkedin,
    FaMailBulk,
    FaUserAlt,
    FaWhatsapp
} from 'react-icons/fa';
import TrackVisibility from 'react-on-screen';
import "../../assets/style/Home.css"
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next'
import { useTranslation } from "react-i18next"
import Backend from 'i18next-http-backend'
import fr from "../../assets/img/francais.png";
import en from "../../assets/img/anglais.png";

i18next.use(initReactI18next)
    .use(Backend)
    .init({
        backend: {
            loadPath: '/translations/{{ lng }}/translations.json'
        },
        lng: 'en',
        fallbackLng: 'fr'
    })


const Accueil: React.FC = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState("");
    const [delta, setDelta] = useState(200 - Math.random() * 100);

    const toRotate = [" Hi ! moi c'est Ravaka"];
    const period = 1000;


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting
            ? fullText.substring(0, text.length - 1)
            : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta((prevDelta) => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(false);
            setDelta(period);
        } else if (isDeleting && updatedText === "") {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    };

    const frImage = fr;
    const enImage = en;
    const { t } = useTranslation('fr', { useSuspense: false });

    const getLanguageFromLocalStorage = () => {
        const storedLanguage = localStorage.getItem('language');
        return storedLanguage || 'en';
    };

    const [selectedImage, setSelectedImage] = useState(getLanguageFromLocalStorage() === 'en' ? enImage : frImage);


    const handleImageChange = (imageName: string) => {
        setSelectedImage(`${imageName}`);
    };

    const handleLangChange = (language: string) => {
        i18next.changeLanguage(language);
        setLanguageInLocalStorage(language);

        if (language === 'fr') {
            handleImageChange(frImage);
        } else if (language === 'en') {
            handleImageChange(enImage);
        }
    };



    const setLanguageInLocalStorage = (language: string) => {
        localStorage.setItem('language', language);
    };

    const setDefaultLanguage = () => {
        const storedLanguage = getLanguageFromLocalStorage();
        i18next.changeLanguage(storedLanguage);

        if (storedLanguage === 'fr') {
            handleImageChange(frImage);
        } else {
            handleImageChange(enImage);
        }
    };

    useEffect(() => {
        setDefaultLanguage();
    }, []);
    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);

        return () => {
            clearInterval(ticker);
        };
    }, [delta, text, tick]);

    return (
        <div>
            <section className="accueil" id="accueil">
                <div className="accueil__container container grid">
                    <div className="accueil__social">
                        <div className="accueil__social-links">
                            <a
                                href="https://www.facebook.com/kavaraania.aina/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="accueil__social-link"
                                data-tooltip="Facebook"
                            >
                                <FaFacebookF />
                            </a>
                            <a
                                href="https://github.com/Ravaka15"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="accueil__social-link"
                                data-tooltip="GitHub"
                            >
                                <FaGithub />
                            </a>
                            <a
                                href="https://www.linkedin.com/in/ravakiniaina-tokifanantenana"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="accueil__social-link"
                                data-tooltip="LinkedIn"
                            >
                                <FaLinkedin />
                            </a>
                            <div className="accueil__social-divider" />
                            <div className='language'>
                                <span
                                    className={`translate ${selectedImage === en ? 'active-lang' : ''}`}
                                    onClick={() => handleLangChange('en')}
                                >
                                    EN
                                </span>
                                <span
                                    className={`translate ${selectedImage === fr ? 'active-lang' : ''}`}
                                    onClick={() => handleLangChange('fr')}
                                >
                                    FR
                                </span>
                            </div>
                        </div>
                        <div className="accueil__social-line" />
                        <span className="accueil__social-follow">{t('home.followMe')}</span>
                    </div>
                    <div className='accueil__introductions'>
                        <div>
                            <div className="accueil__data">
                                <TrackVisibility>
                                    {({ isVisible }) => (
                                        <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>

                                            <h2>
                                                {``} <br></br>{" "}
                                                <span data-period="2000" data-rotate='[ "Web Developer"]'>
                                                    <span className="accueil__title">{text}</span>
                                                </span>
                                            </h2>
                                        </div>
                                    )}
                                </TrackVisibility>
                                <h2 className="accueil__subtitle">-------------- {t('home.frontendDeveloper')} ---------------</h2>
                                <p className="accueil__description">
                                    {t('home.developerDescription')}
                                </p>
                                <a href="#about" className="button"
                                ><FaUserAlt className="button__icon" />
                                    {t('home.aboutMe')}
                                </a>
                            </div>
                            <div className="my__info">
                                <div className="info__item">
                                    <FaFacebookMessenger className="info__icon" />

                                    <div>
                                        <h3 className="info__title">Messenger</h3>
                                        <span className="info__subtitle">kavaraania.aina</span>
                                    </div>
                                </div>

                                <div className="info__item">
                                    <FaWhatsapp className="info__icon" />

                                    <div>
                                        <h3 className="info__title">Whatsapp</h3>
                                        <span className="info__subtitle">+261 34 89 040 76</span>
                                    </div>
                                </div>

                                <div className="info__item">
                                    <FaMailBulk className="info__icon" />

                                    <div>
                                        <h3 className="info__title">E-mail</h3>
                                        <span className="info__subtitle">ravakiniainatokyhary@gmail.com</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="home__content grid">
                            <div className='accueil__image'>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </div>
    );
};

export default Accueil;